import { render, staticRenderFns } from "./CompanyServices.vue?vue&type=template&id=7699925f&"
import script from "./CompanyServices.vue?vue&type=script&lang=js&"
export * from "./CompanyServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports